module.exports = __webpack_public_path__ + "img/productions_25.82420834.png";